// Functions
//import './functions/widgets';
//import './functions/utm-cookies';
//import './functions/data-layer';

// Components
import '../../components/header/header';
//import '../../components/footer/footer';
//import '../../components/calculator/calculator';
import '../../components/tabs/tabs';
import '../../components/accordion/accordion';
import '../../components/modals/modals';
//import '../../components/contact-form/contact-form';

// Gutenberg Blocks
import '../../blocks/testimonials/testimonials';